/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Prep_Action_AddInputs */



/**
* | output |
* | --- |
* | "Add an action point" |
*
* @param {Meeting_Prep_Action_AddInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_prep_action_add = /** @type {((inputs?: Meeting_Prep_Action_AddInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Prep_Action_AddInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Actiepunt toevoegen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter un point d'action")
	return /** @type {LocalizedString} */ ("Add an action point")
});